import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';


import {clearSelection} from 'src/components/data-table-selection';
import {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import {SortDirection, SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';

import {COLUMNS, HEADERS, SELECTION_KEY} from '../../constants';
import {useGetUserConferencesLicense} from '../../hooks/useUserConferencesLicense';
import {
    userConferencesStateActions,
    userConferencesStateSelector,
} from '../../slices/user-conferences-state.slice';
import {userConferencesResultSelector} from '../../slices/user-conferences.slice';

import {HeaderContentBefore} from './header-caption';
import {HeaderSkeleton} from './header-skeleton';

type Props = {
    accountIds: number[],
    totalCount: number,
};

const LicenseEndDateController = ({accountIds, totalCount}: Props) => {
    const dispatch = useDispatch();

    const cacheKeys = useSelector(userConferencesStateSelector);
    const {isLoading, loadingError} = useGetUserConferencesLicense({
        accountIds,
        totalCount,
        columnId: COLUMNS.LICENSE_END_DATE,
    });

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        dispatch(clearSelection(SELECTION_KEY));
        dispatch(userConferencesStateActions.setSortCriteria({
            direction: direction as SortDirection,
            field: AccountSortField.LICENSE_END_DATE,
        }));
    }, [dispatch]);

    return (
        <SortHeaderWithDataTable
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.field === AccountSortField.LICENSE_END_DATE
                ? cacheKeys.sortCriteria.direction
                : null}
            filterActive={true}
            caption={HEADERS[COLUMNS.LICENSE_END_DATE]}
            contentBefore={(isLoading || loadingError)
                ? <HeaderContentBefore isLoading={isLoading} loadingError={loadingError}/>
                : undefined}
            onSort={sort}
        />
    );
};

export const LicenseEndDateHeader = () => {
    const result = useSelector(userConferencesResultSelector);

    return result ? (
        <LicenseEndDateController
            accountIds={result.data.map(({accountId}) => accountId)}
            totalCount={result.totalCount}
        />
    ) : (
        <HeaderSkeleton columnId={COLUMNS.LICENSE_END_DATE}/>
    );
};
